import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
export class UrlValidator {
  static buttonUrlExampleValidator(urlMaxLength: number): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      const value = control.getRawValue();
      if (value) {
        const { url, example } = value;
        if (!url) {
          return { 'button-url': true };
        }
        let validUrl = true;
        try {
          const urlExample = url.replace(/(\{\{1\}\})/gi, example || '');
          new URL(urlExample);
          if (urlExample?.length > urlMaxLength) {
            return {
              'button-url-max-length': true,
            };
          }
        } catch {
          validUrl = false;
        }
        return validUrl ? null : { 'button-url': true };
      }
    };
  }
}
